import React from "react";
import PropTypes from "prop-types";
import { Table, Space, Tooltip } from "antd";
import { EyeOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import "./styles.css";

const ReusableTable = ({
  columns,
  data,
  showView = true,
  showEdit = true,
  showDelete = true,
  onView = () => {},
  onEdit = () => {},
  onDelete = () => {},
  pagination,
}) => {
  const actionColumn = {
    title: "Action",
    key: "action",
    align: "center",
    render: (_, record) => (
      <Space className="action-icons">
        {showView && (
          <Tooltip title="View">
            <EyeOutlined
              style={{ cursor: "pointer" }}
              onClick={() => onView(record)}
            />
          </Tooltip>
        )}
        {showEdit && (
          <Tooltip title="Edit">
            <EditOutlined
              style={{ cursor: "pointer", color: "#9254de" }}
              onClick={() => onEdit(record)}
            />
          </Tooltip>
        )}
        {showDelete && (
          <Tooltip title="Delete">
            <DeleteOutlined
              style={{ cursor: "pointer", color: "#ff4d4f" }}
              onClick={() => onDelete(record)}
            />
          </Tooltip>
        )}
      </Space>
    ),
  };

  return (
    <Table
      columns={[...columns, actionColumn]}
      dataSource={data}
      rowKey="id"
      className="custom-table"
      pagination={pagination || { pageSize: 10 }}
    />
  );
};

ReusableTable.propTypes = {
  columns: PropTypes.array.isRequired,
  data: PropTypes.array,
  showView: PropTypes.bool,
  showEdit: PropTypes.bool,
  showDelete: PropTypes.bool,
  onView: PropTypes.func,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  pagination: PropTypes.number,
};

export default ReusableTable;
